<template>
  <div>
    <router-view></router-view>
    <div class="box" v-if="loadStatu">
      <div id="wifi-loader">
        <svg class="circle-outer" viewBox="0 0 86 86">
          <circle class="back" cx="43" cy="43" r="40"></circle>
          <circle class="front" cx="43" cy="43" r="40"></circle>
          <circle class="new" cx="43" cy="43" r="40"></circle>
        </svg>
        <svg class="circle-middle" viewBox="0 0 60 60">
          <circle class="back" cx="30" cy="30" r="27"></circle>
          <circle class="front" cx="30" cy="30" r="27"></circle>
        </svg>
        <svg class="circle-inner" viewBox="0 0 34 34">
          <circle class="back" cx="17" cy="17" r="14"></circle>
          <circle class="front" cx="17" cy="17" r="14"></circle>
        </svg>
        <div class="text" data-text="Verification in progress, please wait"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/text.css";
import axios from "axios";
import { initApiConfig, verifyCode } from '@/config/api';

export default {
  data() {
    return {
      loadStatu: true, // 加载状态
      apiInitialized: false,
    };
  },
  async created() {
    // 初始化API配置
    await initApiConfig();
    this.apiInitialized = true;
    
    // 页面加载时触发验证逻辑
    this.getFeatureCode();
  },
  methods: {
    async getFeatureCode() {
      // 获取 URL 中的 code 参数
      const code = window.location.pathname.slice(1);

      // 预定义的静态路由（避免冲突）
      const predefinedRoutes = ["", "Home", "Success", "Warning", "Invalid"];
      if (predefinedRoutes.includes(code)) {
        this.updateLoadStatusAndRoute(false, code ? `/${code}` : "/Home");
        return;
      }

      try {
        // 调用后端 API 验证 code
        const data = await verifyCode(code);

        // 处理验证结果
        this.handleVerificationResponse(data);
      } catch (error) {
        // 处理错误
        this.handleError(error);
      }
    },

    // 保留旧方法以便兼容，但实际不再使用
    async verifyFeatureCode(code) {
      console.warn("使用已废弃的方法 verifyFeatureCode");
      return { data: await verifyCode(code) };
    },

    handleVerificationResponse(data) {
      // 映射状态到前端路由
      const statusMapping = {
        valid: "/Success",
        invalid: "/Invalid",
        warning: "/Warning",
      };

      // 根据状态跳转路由
      const routePath = statusMapping[data.status] || "/Home";
      this.updateLoadStatusAndRoute(false, routePath);

      // 如果状态未知，显示错误通知
      if (!statusMapping[data.status]) {
        this.$notify.error({
          title: "ERROR",
          message: data.message || "Unknown error occurred during verification.",
        });
      }
    },

    handleError(error) {
      // 更新状态并跳转到 Home
      this.updateLoadStatusAndRoute(false, "/Home");

      // 显示错误通知
      this.$notify.error({
        title: "ERROR",
        message: (error.response && error.response.data && error.response.data.message) || "An unexpected error occurred."

      });
    },

    updateLoadStatusAndRoute(loadStatu, path) {
      // 更新加载状态并跳转路由
      this.loadStatu = loadStatu;
      this.$router.push({ path });
    },
  },
};
</script>

<style>
/* 加载动画样式 */
.box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
#wifi-loader {
  --background: #62abff;
  --front-color: #4f29f0;
  --back-color: #c3c8de;
  --text-color: #414856;
  width: 10rem;
  height: 10rem;
  border-radius: 50px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

#wifi-loader svg {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

#wifi-loader svg circle {
  position: absolute;
  fill: none;
  stroke-width: 6px;
  stroke-linecap: round;
  stroke-linejoin: round;
  transform: rotate(-100deg);
  transform-origin: center;
}

#wifi-loader svg circle.back {
  stroke: var(--back-color);
}

#wifi-loader svg circle.front {
  stroke: var(--front-color);
}

#wifi-loader svg.circle-outer {
  height: 100%;
  width: 100%;
}

#wifi-loader svg.circle-middle {
  height: 60%;
  width: 60%;
}

#wifi-loader svg.circle-inner {
  height: 34%;
  width: 34%;
}

#wifi-loader .text {
  position: absolute;
  bottom: -50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: lowercase;
  font-weight: bold;
  font-size: 1rem;
  letter-spacing: 0.2px;
  width: 100vw;
}

@keyframes circle-outer {
  0% {
    stroke-dashoffset: 25;
  }
  100% {
    stroke-dashoffset: 276;
  }
}
</style>
